<template lang="pug">
v-dialog(
  v-model="dialog"
  width="450px"
  dark
)
  v-card(outlined).pa-4
    p.title Изменение часового пояса
    v-text-field( filled label="Заголовок" v-model="form.title")
    v-text-field( filled label="Зона" v-model="form.zone")

    v-btn.mr-2(color="success" @click="handlerForm") {{ data ? 'Обновить' : "Создать"}}
    v-btn.mr-2(color="error" @click="deleteZone" v-if="data") Удалить
    v-btn(@click="closeForm" text) Отменить
</template>
<script>
import CRUDTimezones from '@/services/API/timezone';

export default {
  props: {
    value: { required: true, type: Boolean },
    data: { required: false, type: [Object, Boolean], default: false },
  },
  data() {
    return {
      dialog: false,
      id: 0,
      form: {
        zone: '',
        title: '',
      },
    };
  },
  computed: {
    getTitle() {
      return this.data ? 'Изменение часового пояса' : 'Создание нового часового пояса';
    },
  },
  watch: {
    dialog(v) {
      if (!v) this.closeForm();
    },
    value: {
      immediate: true,
      async handler(v) {
        this.dialog = v;
      },
    },
    data: {
      immediate: true,
      handler(v) {
        this.form.zone = v.zone;
        this.form.title = v.title;
        this.id = v.id;
      },
    },
  },
  methods: {
    closeForm(val) {
      this.form = {};
      this.dialog = false;
      this.$emit('close', val || []);
    },
    async handlerForm() {
      if (this.id > 0) {
        try {
          await CRUDTimezones.update(this.id, this.form);
          this.$toast.success('Вы успешно изменили форму');
          this.closeForm();
        } catch (e) {
          this.$toast.error(e.response.data.result_message);
        }
      } else {
        try {
          const response = await CRUDTimezones.create(this.form);
          this.$toast('Вы успешно создали форму');
          this.closeForm(response.data.data);
        } catch (e) {
          this.$toast.error(e.response.data.result_message);
        }
      }
    },
    async deleteZone() {
      try {
        await CRUDTimezones.delete(this.id);
        this.$toast('Вы успешно удалили часовой пояс');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
<style lang="scss" scoped/>
